import jwt_decode from 'jwt-decode';

/** Refresh this long before `exp`, to cover clock skew and the request's own upload time. */
export const ACCESS_TOKEN_REFRESH_MARGIN_SECONDS = 60;

/**
 * Whether the access token is expired or will be within `marginSeconds`.
 * A token that cannot be decoded, or carries no `exp`, is left alone: the 401 handler still
 * covers it, and refreshing on every request for an odd token would be worse.
 */
export const isAccessTokenExpiring = (
  token: string | undefined,
  marginSeconds: number = ACCESS_TOKEN_REFRESH_MARGIN_SECONDS,
  nowMs: number = Date.now()
): boolean => {
  if (!token) return false;
  try {
    const { exp } = jwt_decode<{ exp?: number }>(token);
    if (typeof exp !== 'number') return false;
    return exp * 1000 - nowMs <= marginSeconds * 1000;
  } catch {
    return false;
  }
};

/**
 * Whether a request carries a file body (multipart upload).
 *
 * These cannot rely on the 401-then-refresh path: the gateway rejects an expired token before
 * reading the body and closes the connection, so the reverse proxy in front of it answers 502
 * instead of 401 and the refresh never runs.
 */
export const hasFileBody = (data: unknown): boolean =>
  (typeof FormData !== 'undefined' && data instanceof FormData) ||
  (typeof Blob !== 'undefined' && data instanceof Blob);
